import { GlobalStyles } from "@mui/material";

export const BeaconStyles = () => {
  return <GlobalStyles styles={{ ".BeaconContainer": { left: "unset !important" } }} />;
};
